import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
// import Home from "../views/Home.vue";
import Layout from "@/layout/index.vue";
import { VIEW_ACCESS } from "@/constants/accessList.constant";

export const baseRoutes: Array<RouteRecordRaw> = [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/login/index.vue"),
    meta: { title: "ログイン", showOnMenu: false },
  },
  {
    path: "/reset-password",
    name: "resetPassword",
    component: () => import("../views/resetPassword/index.vue"),
    meta: { title: "パスワード再発行", showOnMenu: false },
  },
  {
    path: "/set-password",
    name: "setPassword",
    component: () => import("../views/setPassword/index.vue"),
    meta: { title: "パスワード設定", showOnMenu: false },
  },
  {
    path: "/404",
    component: () => import("../views/login/index.vue"),
    meta: { title: "404", showOnMenu: false },
  },
  {
    path: "/terms",
    name: "terms",
    component: () => import("@/views/terms/index.vue"),
    meta: {
      title: "利用規約",
      showOnMenu: false,
    },
  },
  {
    path: "/link",
    component: Layout,
    meta: { title: "リンク", showOnMenu: false },
    children: [
      {
        path: "docs",
        name: "documents",
        component: () => import("@/views/document/index.vue"),
        meta: {
          title: "ドキュメント",
          showOnMenu: false,
        },
      },
      {
        path: "toiawase-form/:id?",
        name: "toiawaseForm",
        component: () => import("@/views/toiawase/Detail.vue"),
        meta: {
          title: "問い合わせ",
          showOnMenu: false,
        },
      },
    ],
  },
];

export const asyncRoutes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/shinsei-list",
    component: Layout,
    meta: {
      title: "申請・問い合わせ",
      showOnMenu: true,
      roles: ["ULT1", "ULT2"],
    },
    children: [
      {
        path: "shinsei-list",
        name: "shinseiList",
        component: () => import("@/views/shinsei/index.vue"),
        meta: {
          title: "申請一覧",
          showOnMenu: true,
        },
      },
      {
        path: "shinsei-detail/:id?",
        name: "shinseiDetail",
        component: () => import("@/views/shinsei/Detail.vue"),
        meta: {
          title: "申請詳細",
          showOnMenu: false,
        },
      },
      {
        path: "toiawase-list",
        name: "toiawaseList",
        component: () => import("@/views/toiawase/index.vue"),
        meta: {
          title: "問い合わせ一覧",
          showOnMenu: true,
        },
      },
    ],
  },
  {
    path: "/",
    redirect: "/shinsei-list",
    component: Layout,
    meta: {
      title: "申請",
      showOnMenu: true,
      roles: ["USE1", "USE2"],
    },
    children: [
      {
        path: "shinsei-list",
        name: "shinseiList",
        component: () => import("@/views/shinsei/index.vue"),
        meta: {
          title: "申請一覧",
          showOnMenu: true,
        },
      },
      {
        path: "shinsei-detail/:id?",
        name: "shinseiDetail",
        component: () => import("@/views/shinsei/Detail.vue"),
        meta: {
          title: "申請詳細",
          showOnMenu: false,
        },
      },
    ],
  },
  {
    path: "/user",
    redirect: "/user/shoninsha-list",
    component: Layout,
    meta: { title: "承認者・申請者", showOnMenu: true },
    children: [
      {
        path: "shoninsha-list",
        name: "shoninshaList",
        component: () => import("@/views/shoninsha/index.vue"),
        meta: {
          title: "承認者一覧",
          showOnMenu: true,
          roles: VIEW_ACCESS.shoninshaView,
        },
      },
      {
        path: "shinseisha-list",
        name: "shinseishaList",
        component: () => import("@/views/shinseisha/index.vue"),
        meta: {
          title: "申請者一覧",
          showOnMenu: true,
        },
      },
      {
        path: "kaisha-list",
        name: "kaishaList",
        component: () => import("../views/kaisha/index.vue"),
        meta: {
          title: "会社一覧",
          showOnMenu: true,
          roles: VIEW_ACCESS.kaishaView,
        },
      },
      {
        path: "kaisha-group-list",
        name: "kaishaGroupList",
        component: () => import("../views/kaishaGroup/index.vue"),
        meta: {
          title: "会社グループ一覧",
          showOnMenu: true,
        },
      },
      {
        path: "profile",
        name: "profile",
        component: () => import("../views/profile/index.vue"),
        meta: { title: "個人設定", showOnMenu: false },
      },
    ],
  },
  {
    path: "/setting",
    name: "setting",
    component: Layout,
    meta: {
      title: "設定変更",
      showOnMenu: true,
      roles: VIEW_ACCESS.settingView,
    },
    children: [
      {
        path: "shonin-comment-setting",
        name: "shoninCommentSetting",
        component: () => import("@/views/shoninComment/index.vue"),
        meta: {
          title: "承認コメント補助設定",
          showOnMenu: true,
        },
      },
      {
        path: "mente-setting",
        name: "menteSetting",
        component: () => import("@/views/menteSetting/index.vue"),
        meta: {
          title: "メンテ通知設定",
          showOnMenu: true,
        },
      },
    ],
  },
  {
    path: "/maintenance",
    redirect: "/maintenance/gyoushu-bunrui-list",
    component: Layout,
    meta: {
      title: "マスタメンテ",
      showOnMenu: true,
      roles: VIEW_ACCESS.maintainView,
    },
    children: [
      {
        path: "gyoushu-bunrui-list",
        name: "gyoushuBunruiList",
        component: () => import("@/views/gyoushu/index.vue"),
        meta: {
          title: "業種分類マスタ",
          showOnMenu: true,
        },
      },
      {
        path: "shinsei-bunrui-list",
        name: "shinseiBunruiList",
        component: () => import("@/views/shinseiBunrui/index.vue"),
        meta: {
          title: "申請分類マスタ",
          showOnMenu: true,
        },
      },
    ],
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
    meta: { title: "404", showOnMenu: false },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes: baseRoutes,
  scrollBehavior(to, from, savedPosition) {
    return {
      el: ".el-scrollbar",
      top: 0,
    };
  },
});

export default router;
